import { render, staticRenderFns } from "./BillingAddressForm.vue?vue&type=template&id=e6c06844"
import script from "./BillingAddressForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingAddressForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports